import React from 'react'

const CardColFour = ({children}) => {
  return (
    <div className="card-col-four">{children}</div>
  )
}

export default CardColFour